import { Component, OnInit } from '@angular/core';
import { Brand } from 'src/brands/brand';
import { LocaleService, localeDisplayName } from 'src/app/services/locale.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public isMenuCollapsed = true;

  public navbarTitle = '-';

  public readonly messagesEnabled = Brand.messagesEnabled;

  /** The brand's cultures, labelled in their own language. The picker is hidden when there's only one. */
  public readonly cultures: { code: string, name: string }[];

  public readonly currentCulture: string;

  constructor(private locale: LocaleService) {
    this.cultures = locale.supported.map(code => ({ code, name: localeDisplayName(code) }));
    this.currentCulture = locale.current;
  }

  ngOnInit(): void {
    this.navbarTitle = Brand.navbarTitle;
  }

  selectCulture(culture: string): void {
    this.locale.select(culture);
  }
}
